module.exports = __webpack_public_path__ + "static/media/EA_Books.cba1b595.png";